module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content--first lightpink text--darkgreen clear"
  }, [_c('div', {
    staticClass: "column--single img--100"
  }, [_c('div', {
    staticClass: "column--single"
  }, [_vm._l((_vm.animations), function(animation, index) {
    return _c('expressive-type-section', {
      key: index,
      attrs: {
        "name": animation.name,
        "en": animation.en,
        "kr": animation.kr,
        "type-index": index,
        "texts": animation.texts,
        "is-last": index === Object.keys(_vm.animations).length - 1,
        "blurring": animation.blurring
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "spacer--small clear"
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4ccbae4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExpressiveTypeAnimations.vue
// module id = 159
// module chunks = 0